import React, { useState, useEffect } from "react";
import Title from "../../../../components/common/Title/Title";
import AppRoutePath from "../../../../router/AppRoutePath";
import { Checkbox, Input } from "antd";
import Cookies from "js-cookie";
import { Button } from "react-bootstrap";
import moment from "moment";
import {
  convertCategory,
  convertOutletList,
  convertToRoman,
} from "../../helpers/index";
import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import TextInput from "../../components/TextInput";
import MultipleSelect from "../../components/MultipleSelect";
import "../styles.css";
import RadioComponent from "../../components/RadioComponent";
import {
  dataBreadcrumb,
  pawnType,
  paymentType,
  tenorType,
} from "../add_loan/constants";
import SelectCurrencyInput from "../../components/SelectCurrencyInput";
import RegulerInformation from "../../components/RegulerInformation";
import TenorCalculation from "../../components/TenorCalculation";
import ErrorDiv from "../../../../components/helpers/ErrorDiv";
import IsEmpty from "../../../../components/helpers/IsEmpty";
import { useHistory } from "react-router-dom";
import httpclient from "../../../../components/httpclient";
import SwalToast from "../../../../components/helpers/SwalToast";
import CustomBreadcrumb from "../../../../components/common/Breadcrumb/CustomBreadcrumb";
import NumberFormat from "react-number-format";
import { convertNotificationList } from "../../helpers/convertNotificationGroupList";

export default function AddCampaignDefault() {
  const history = useHistory();
  const [campaignName, setCampaignName] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState([
    "balloon_payment",
  ]);
  const [selectedTenorType, setSelectedTenorType] = useState([]);
  const [selectedTenor, setSelectedTenor] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState([]);
  const [selectedPawnType, setSelectedPawnType] = useState(pawnType[0].value);
  const [paymentTypeValue, setPaymentTypeValue] = useState(
    paymentType[0].value
  );
  const [tenorTypeValue, setTenorTypeValue] = useState(tenorType[0].value);
  const [dateValue, setDateValue] = useState([]);

  const [currencyMinLoan, setCurrencyMinLoan] = useState("percent");
  const [minLoanValue, setMinLoanValue] = useState();
  const [currencyMaxLoan, setCurrencyMaxLoan] = useState("percent");
  const [maxLoanValue, setMaxLoanValue] = useState();
  const [currencyCapitalLoan, setCurrencyCapitalLoan] = useState("percent");
  const [capitalLoanValue, setCapitalLoanValue] = useState();
  const [currencyFeeAdmin, setCurrencyFeeAdmin] = useState("percent");
  const [feeAdminRupiah, setFeeAdminRupiah] = useState();
  const [feeAdminPercent, setFeeAdminPercent] = useState();
  const [currencyFeeSavingInsurance, setCurrencyFeeSavingInsurance] =
    useState("percent");
  const [feeSavingInsuranceValue, setFeeSavingInsuranceValue] = useState();
  const [currencyLateCharge, setCurrencyLateCharge] = useState("percent");
  const [lateChargeValue, setLateChargeValue] = useState();
  const [currencyFeeAuction, setCurrencyFeeAuction] = useState("percent");
  const [feeAuctionValue, setFeeAuctionValue] = useState();
  const [currencyFeeSavingLate, setCurrencyFeeSavingLate] = useState("percent");
  const [feeSavingLateValue, setFeeSavingLate] = useState();
  const [maxLate, setMaxLate] = useState();
  const [maxExtension, setMaxExtension] = useState();
  const [gracePeriod, setGracePeriod] = useState();

  const [tenor, setTenor] = useState();
  const [tenorCalculation, setTenorCalculation] = useState([]);
  const [showTenorCalculation, setShowTenorCalculation] = useState(false);
  const [feeInsuranceValue, setFeeInsuranceValue] = useState();
  const [feeSavingValue, setFeeSavingValue] = useState();

  const [errorTenor, setErrorTenor] = useState();
  const [errorName, setErrorName] = useState();
  const [errorCategory, setErrorCategory] = useState();
  const [errorNotifGroup, setErrorNotifGroup] = useState();
  const [errorOutlet, setErrorOutlet] = useState();
  const [errorPawnType, setErrorPawnType] = useState();
  const [errorMinLoan, setErrorMinLoan] = useState();
  const [errorMaxLoan, setErrorMaxLoan] = useState();
  const [errorCapitalLoan, setErrorCapitalLoan] = useState();
  const [errorFeeAdmin, setErrorFeeAdmin] = useState();
  const [errorChargeLate, setErrorChargeLate] = useState();
  const [errorSavingInsurance, setErrorSavingInsurance] = useState();
  const [errorSavingLate, setErrorSavingLate] = useState();
  const [errorFeeAuction, setErrorFeeAuction] = useState();
  const [errorMaxExtend, setErrorMaxExtend] = useState();
  const [errorGracePeriod, setErrorGracePeriod] = useState();
  const [errorMaxLate, setErrorMaxLate] = useState();
  const [errorDate, setErrorDate] = useState();
  const [errorPaymentType, setErrorPaymentType] = useState();
  const [notificationGroups, setNotificationGroups] = useState([]);
  const [selectedNotifGroup, setSelectedNotifGroup] = useState();
  const [errorSaving, setErrorSaving] = useState();
  const [errorInsurance, setErrorInsurance] = useState();

  useEffect(() => {
    getCategory();
    getOutlet();
    getNotificationGroup();
  }, []);

  useEffect(() => {
    if (!IsEmpty(feeSavingValue) && !IsEmpty(feeInsuranceValue)) {
      if (currencyFeeSavingInsurance === 'percent') {
        setFeeSavingInsuranceValue(parseFloat(feeSavingValue + feeInsuranceValue))
      } else {
        setFeeSavingInsuranceValue(parseInt(feeSavingValue + feeInsuranceValue))
      }
    }
  }, [feeSavingValue, feeInsuranceValue]);

  const getNotificationGroup = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}notification-group/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setNotificationGroups(convertNotificationList(response.data.data));
      }
    );
  };

  const getCategory = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setCategoryList(convertCategory(response.data.data.items));
      }
    );
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data.items));
      }
    );
  };

  const handleSelectChange = (field, data) => {
    if (field === "outlet") {
      let outlet = [];
      data.map((item) => {
        outlet.push({ outlet_id: item.value });
        setSelectedOutlet(outlet);
      });
    } else if (field === "category") {
      let category = [];
      category.push({ product_category_id: data.value });
      setSelectedCategory(category);
    } else if (field === "notification") {
      setSelectedNotifGroup(data.value);
    }
  };

  const onChangeRadio = (id, data) => {
    setTenor("");
    if (id === "paymentType") {
      setPaymentTypeValue(data.value);
    } else if (id === "tenorType") {
      setTenorTypeValue(data.value);
    } else if (id === "pawnType") {
      setSelectedPawnType(data.value);
    }
  };

  const handleChangeInput = (id, data) => {
    if (data) {
      let { floatValue } = data;
      if (id === "minLoan") {
        setMinLoanValue(floatValue);
      } else if (id === "maxLoan") {
        setMaxLoanValue(floatValue);
      } else if (id === "capitalLoan") {
        setCapitalLoanValue(floatValue);
      } else if (id === "feeSavingInsurance") {
        setFeeSavingInsuranceValue(floatValue);
      } else if (id === "lateCharge") {
        setLateChargeValue(floatValue);
      } else if (id === "feeAuction") {
        setFeeAuctionValue(floatValue);
      } else if (id === "feeSavingLate") {
        setFeeSavingLate(floatValue);
      }
    }
  };

  const handleChangeCurrency = (id, data) => {
    if (id === "minLoan") {
      setCurrencyMinLoan(data);
    } else if (id === "maxLoan") {
      setCurrencyMaxLoan(data);
    } else if (id === "capitalLoan") {
      setCurrencyCapitalLoan(data);
    } else if (id === "feeAdmin") {
      setCurrencyFeeAdmin(data);
    } else if (id === "feeSavingInsurance") {
      setCurrencyFeeSavingInsurance(data);
    } else if (id === "lateCharge") {
      setCurrencyLateCharge(data);
    } else if (id === "feeAuction") {
      setCurrencyFeeAuction(data);
    } else if (id === "feeSavingLate") {
      setCurrencyFeeSavingLate(data);
    }
  };
  const onChangePawnType = (e) => {
    setSelectedPawnType(e);
  };

  const onChangePaymentType = (e) => {
    setSelectedPaymentType(e);
  };

  const handleEnter =
    (type = "enter") =>
      (event) => {
        setErrorTenor("");
        const { value } = event.target;
        if (isNaN(value)) {
          setErrorTenor("Tenor Pinjaman Harus Angka");
        } else if (event.key === "Enter" || event.keyCode === 13) {
          console.log({
            product_category_id: selectedCategory?.map((x) =>
              parseInt(x.product_category_id)
            ),
            outlet_id: selectedOutlet.map((x) => parseInt(x.outlet_id)),
            tenor_days: value,
          });

          let url = `${process.env.REACT_APP_BASE_API_URL}promo-loan/check-tenor`;
          httpclient
            .GET(url, {
              product_category_id: selectedCategory?.map((x) =>
                parseInt(x.product_category_id)
              ),
              outlet_id: selectedOutlet.map((x) => parseInt(x.outlet_id)),
              tenor_days: value,
            })
            .then((response) => {
              console.log(response.data.data);
              if (response.data.data) {
                if (tenorTypeValue === "non_reguler") {
                  setShowTenorCalculation(true);
                  let tenorCal = [];
                  let index = 0;
                  if (event.keyCode === 13) {
                    if (!isNaN(value)) {
                      let valueNumber = parseInt(value);

                      while (valueNumber > 120) {
                        if (valueNumber >= 120) {
                          if (index === 0) {
                            tenorCal.push({
                              label: "Masa Pinjaman :",
                              value: "120 Hari (4 Bulan)",
                            });
                          }
                        }
                        valueNumber = valueNumber - 120;
                        index++;
                        if (valueNumber > 120) {
                          tenorCal.push({
                            label: `Perpanjang ${convertToRoman(index)} :`,
                            value: "120 Hari (4 Bulan)",
                          });
                        }

                        if (valueNumber <= 120) {
                          tenorCal.push({
                            label:
                              index === 0
                                ? "Masa Pinjaman :"
                                : `Perpanjang ${convertToRoman(index)}:`,
                            value: `${valueNumber} Hari (${Math.floor(
                              valueNumber / 30
                            )} Bulan${valueNumber % 30 !== 0
                              ? ` , ${valueNumber % 30} Hari`
                              : ""
                              })`,
                          });
                        }
                      }

                      if (valueNumber <= 120 && index === 0) {
                        tenorCal.push({
                          label:
                            index === 0
                              ? "Masa Pinjaman :"
                              : `Perpanjang ${convertToRoman(index)}:`,
                          value: `${valueNumber} Hari (${Math.floor(
                            valueNumber / 30
                          )} Bulan${valueNumber % 30 !== 0
                            ? ` , ${valueNumber % 30} Hari`
                            : ""
                            })`,
                        });
                      }
                    }
                    tenorCal.push({
                      label: `Total :`,
                      value: `${index + 1} Masa Pinjaman`,
                    });
                    setTenorCalculation(tenorCal);
                  }
                } else if (tenorTypeValue === "reguler") {
                  if (value > 120) {
                    setErrorTenor("Jenis Tenor Reguler Maksimal 120 Hari");
                  }
                }
              } else {
                setErrorTenor(`Tenor Pinjaman ${value} Hari Sudah Digunakan`);
              }
            });
        }
      };

  const handleDateChange = (event) => {
    setDateValue([moment(event[0]._d), moment(event[1]._d)]);
  };

  const handleBlur = (event) => {
    console.log(event);
  };

  const validate = () => {
    let validate = true;
    setErrorName();
    setErrorCategory();
    setErrorOutlet();
    setErrorTenor();
    setErrorPawnType();
    setErrorMinLoan();
    setErrorMaxLoan();
    setErrorCapitalLoan();
    setErrorFeeAdmin();
    setErrorSavingInsurance();
    setErrorChargeLate();
    setErrorSavingLate();
    setErrorFeeAuction();
    setErrorMaxExtend();
    setErrorMaxLate();
    setErrorDate();
    setErrorPaymentType();
    setErrorNotifGroup();
    setErrorGracePeriod();
    setErrorInsurance();
    setErrorSaving();

    if (IsEmpty(campaignName)) {
      validate = false;
      setErrorName("Nama Harus Diisi");
    }
    if (selectedPaymentType.length === 0) {
      validate = false;
      setErrorPaymentType("Jenis Pembayaran Harus Dipilih");
    }
    if (selectedCategory.length === 0) {
      validate = false;
      setErrorCategory("Kategori Produk Harus Dipilih");
    }
    if (selectedPawnType !== "pick_up") {
      if (selectedOutlet.length === 0) {
        validate = false;
        setErrorOutlet("Outlet Harus Dipilih");
      }
    }
    if (IsEmpty(tenor)) {
      validate = false;
      setErrorTenor("Tenor Pinjaman Harus Di isi");
    }
    if (tenorTypeValue === "reguler") {
      if (tenor > 120) {
        validate = false;
        setErrorTenor("Jenis Tenor Reguler Maksimal 120 Hari");
      }
    }
    if (tenorTypeValue === "non_reguler") {
      if (tenor <= 120) {
        setErrorTenor("Jenis Tenor Non Reguler Harus Lebih dari 120 Hari");
      }
    }
    if (selectedPawnType.length === 0) {
      validate = false;
      setErrorPawnType("Jenis Gadai Harus Dipilih");
    }
    if (IsEmpty(minLoanValue) && minLoanValue !== 0) {
      validate = false;
      setErrorMinLoan("Minimum Pinjaman Harus Diisi");
    }
    if (IsEmpty(maxLoanValue) && maxLoanValue !== 0) {
      validate = false;
      setErrorMaxLoan("Maksimum Pinjaman Harus Diisi");
    }
    if (IsEmpty(capitalLoanValue) && capitalLoanValue !== 0) {
      validate = false;
      setErrorCapitalLoan("Biaya Sewa Modal Harus Diisi");
    }
    if (
      (IsEmpty(feeAdminRupiah) && feeAdminRupiah !== 0) ||
      (IsEmpty(feeAdminPercent) && feeAdminPercent !== 0)
    ) {
      validate = false;
      setErrorFeeAdmin("Biaya Administrasi Harus Diisi");
    }
    if (IsEmpty(feeSavingValue) && feeSavingValue !== 0) {
      validate = false;
      setErrorSaving("Biaya Penyimpanan Harus Diisi");
    }
    if (IsEmpty(feeInsuranceValue) && feeInsuranceValue !== 0) {
      validate = false;
      setErrorInsurance("Biaya Asuransi Harus Diisi");
    }
    if (IsEmpty(feeSavingInsuranceValue) && feeSavingInsuranceValue !== 0) {
      validate = false;
      setErrorSavingInsurance("Biaya Simpan & Asuransi Harus Diisi");
    }
    if (IsEmpty(lateChargeValue) && lateChargeValue !== 0) {
      validate = false;
      setErrorChargeLate("Biaya Denda Keterlambatan Harus Diisi");
    }
    if (IsEmpty(feeSavingLateValue) && feeSavingLateValue !== 0) {
      validate = false;
      setErrorSavingLate("Biaya Simpan Keterlambatan Harus Diisi");
    }
    if (IsEmpty(feeAuctionValue) && feeAuctionValue !== 0) {
      validate = false;
      setErrorFeeAuction("Biaya Jasa Lelang Harus Diisi");
    }
    if (IsEmpty(maxExtension) && maxExtension !== 0) {
      validate = false;
      setErrorMaxExtend("Maksimum Perpanjangan Harus Diisi");
    }
    if (IsEmpty(maxLate) && maxLate !== 0) {
      validate = false;
      setErrorMaxLate("Maksimum Keterlambatan Harus Diisi");
    }
    if (IsEmpty(selectedNotifGroup)) {
      validate = false;
      setErrorNotifGroup("Notifikasi Harus Dipilih");
    }
    if (IsEmpty(gracePeriod)) {
      validate = false;
      setErrorGracePeriod("Masa Tenggang Harus Diisi");
    }
    return validate;
  };

  const onSubmit = () => {
    if (!validate()) return;
    let url = `${process.env.REACT_APP_BASE_API_URL}promo-loan/default`;
    let data = {
      name: campaignName,
      payment_type: selectedPaymentType.toString(),
      tenor_type: tenorTypeValue,
      description: " ",
      max_late: parseInt(maxLate),
      max_extension: parseInt(maxExtension),
      max_loan_rupiah:
        currencyMaxLoan === "rupiah" ? parseInt(maxLoanValue) : 0,
      max_loan_percentage:
        currencyMaxLoan === "percent" ? parseFloat(maxLoanValue) : 0,
      min_loan_rupiah:
        currencyMinLoan === "rupiah" ? parseInt(minLoanValue) : 0,
      min_loan_percentage:
        currencyMinLoan === "percent" ? parseFloat(minLoanValue) : 0,
      fee_admin_rupiah: parseInt(feeAdminRupiah),
      fee_admin_percentage: parseFloat(feeAdminPercent),
      fee_saving_assurance_rupiah:
        currencyFeeSavingInsurance === "rupiah"
          ? parseInt(feeSavingInsuranceValue)
          : 0,
      fee_saving_assurance_percentage:
        currencyFeeSavingInsurance === "percent"
          ? parseFloat(feeSavingInsuranceValue)
          : 0,
      fee_auction_rupiah:
        currencyFeeAuction === "rupiah" ? parseInt(feeAuctionValue) : 0,
      fee_auction_percentage:
        currencyFeeAuction === "percent" ? parseFloat(feeAuctionValue) : 0,
      capital_loan_rupiah:
        currencyCapitalLoan === "rupiah" ? parseInt(capitalLoanValue) : 0,
      capital_loan_percentage:
        currencyCapitalLoan === "percent" ? parseFloat(capitalLoanValue) : 0,
      late_charge_rupiah:
        currencyLateCharge === "rupiah" ? parseInt(lateChargeValue) : 0,
      late_charge_percentage:
        currencyLateCharge === "percent" ? parseFloat(lateChargeValue) : 0,
      tenor_days: parseInt(tenor),
      start_date: dateValue[0]?.format("YYYY-MM-DD"),
      end_date: dateValue[1]?.format("YYYY-MM-DD"),
      promo_loan_outlets:
        selectedPawnType === "pick_up" ? [{ outlet_id: 0 }] : selectedOutlet,
      promo_loan_products: selectedCategory,
      fee_storage_percentage:
        currencyFeeSavingLate === "percent"
          ? parseFloat(feeSavingLateValue)
          : 0,
      fee_storage_rupiah:
        currencyFeeSavingLate === "rupiah" ? parseInt(feeSavingLateValue) : 0,
      gadai_type: selectedPawnType,
      notification_group_id: selectedNotifGroup,
      grace_period: parseInt(gracePeriod),
      fee_saving_assurance_sharing_saving_rp: currencyFeeSavingInsurance === "rupiah" ? parseInt(feeSavingValue) : 0,
      fee_saving_assurance_sharing_saving: currencyFeeSavingInsurance === "percent" ? parseInt(feeSavingValue) : 0,
      fee_saving_assurance_sharing_assurance_rp: currencyFeeSavingInsurance === "rupiah" ? parseInt(feeInsuranceValue) : 0,
      fee_saving_assurance_sharing_assurance: currencyFeeSavingInsurance === "percent" ? parseInt(feeInsuranceValue) : 0,
    };
    setSubmitting(true);
    console.log(data);
    httpclient
      .POST(url, data)
      .then((response) => {
        console.log(response);
        history.push(AppRoutePath.CAMPAIGN_DEFAULT, { list: 'loan' });
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  return (
    <div className="px-3">
      <div className="pt-4 d-flex justify-content-between">
        <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Tambah Reguler Offer Pinjaman Balloon Payment"} />
          <CustomBreadcrumb current={dataBreadcrumb} />
        </div>
      </div>
      <div className="container-campaign">
        <div className="container-input-1">
          <div className="container-input my-3">
            <TextInput
              label="Nama Promo"
              onChange={(e) => setCampaignName(e.target.value)}
            />
            <ErrorDiv error={errorName} />
            <hr style={{ border: "1px dashed #DCDCDC" }} />
            <div className="container-sk">
              <div className="label-campaign">Syarat & Ketentuan</div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <RadioComponent
                    value={selectedPawnType}
                    options={pawnType}
                    label="Jenis Gadai"
                    onChange={onChangeRadio}
                    id="pawnType"
                  />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <MultipleSelect
                    isMulti={false}
                    options={categoryList}
                    label="Kategori Produk"
                    id={"category"}
                    onSelectChange={handleSelectChange}
                  />
                  <ErrorDiv error={errorCategory} />
                </div>
                <div className="col-6 pr-0">
                  <MultipleSelect
                    isDisabled={selectedPawnType === "pick_up"}
                    isMulti={true}
                    options={outletList}
                    label="Outlet/Cabang"
                    id={"outlet"}
                    onSelectChange={handleSelectChange}
                  />
                  <ErrorDiv error={errorOutlet} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <RadioComponent
                    value={tenorTypeValue}
                    options={tenorType}
                    label="Jenis Tenor"
                    onChange={onChangeRadio}
                    id="tenorType"
                  />
                </div>
                <div className="col-6 pr-0">
                  <p>Jenis Pembayaran</p>
                  <Checkbox.Group
                    value={selectedPaymentType}
                    defaultChecked={true}
                    className="pawn-type-checkbox"
                    options={paymentType}
                  // onChange={onChangePaymentType}
                  />
                  <ErrorDiv error={errorPaymentType} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <TextInput
                    handleBlur={handleEnter}
                    handleEnter={handleEnter}
                    suffix="Hari"
                    value={tenor}
                    label="Tenor Pinjaman"
                    onChange={(e) => setTenor(e.target.value)}
                  />
                  <ErrorDiv error={errorTenor} />
                  {showTenorCalculation && tenorTypeValue === "non_reguler" ? (
                    <TenorCalculation
                      tenorCalculation={tenorCalculation}
                      key={tenorCalculation?.label}
                    />
                  ) : null}
                </div>

                <div className="col-6 pr-0">
                  <MultipleSelect
                    isMulti={false}
                    options={notificationGroups}
                    label="Notifikasi"
                    id={"notification"}
                    onSelectChange={handleSelectChange}
                  />
                  <ErrorDiv error={errorNotifGroup} />
                </div>
              </div>
            </div>
            <hr style={{ border: "1px dashed #DCDCDC" }} />
            <div className="container-sk">
              <div className="label-campaign">Promo yang Didapat</div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="minLoan"
                    // value={minLoanValue}
                    label="Minimum Pinjaman"
                    defaultValue={currencyMinLoan}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorMinLoan} />
                </div>
                <div className="col-6 pr-0">
                  <SelectCurrencyInput
                    id="maxLoan"
                    label="Loan to Value (Maksimum Pinjaman)"
                    defaultValue={currencyMaxLoan}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorMaxLoan} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="capitalLoan"
                    label="Biaya Sewa Modal"
                    defaultValue={currencyCapitalLoan}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorCapitalLoan} />
                </div>
                <div className="col-6 pr-0">
                  <p>Biaya Administrasi</p>
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeAdminPercent}
                        isNumericString={true}
                        onValueChange={(e) => setFeeAdminPercent(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: -20, marginTop: 6 }}
                      >
                        %
                      </p>
                    </div>
                    <div className="col-6 pl-1 pr-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeAdminRupiah}
                        isNumericString={true}
                        onValueChange={(e) => setFeeAdminRupiah(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: -50, marginTop: 6 }}
                      >
                        Rupiah
                      </p>
                    </div>
                  </div>
                  <ErrorDiv error={errorFeeAdmin} />
                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    value={feeSavingInsuranceValue}
                    disabled={true}
                    id="feeSavingInsurance"
                    label="Biaya Simpan & Asuransi"
                    defaultValue={currencyFeeSavingInsurance}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorSavingInsurance} />
                </div>
                <div className="col-6 pr-0">
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <p>Pembagian Biaya Simpan</p>
                    </div>
                    <div className="col-6 pl-1 d-flex align-items-center">
                      <p>Pembagian Biaya Asuransi</p>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeSavingValue}
                        isNumericString={true}
                        onValueChange={(e) => setFeeSavingValue(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: currencyFeeSavingInsurance === 'percent' ? -20 : -50, marginTop: 6 }}
                      >
                        {currencyFeeSavingInsurance === 'percent' ? '%' : 'Rupiah'}
                      </p>
                    </div>
                    <div className="col-6 pl-1 pr-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeInsuranceValue}
                        isNumericString={true}
                        onValueChange={(e) => setFeeInsuranceValue(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: currencyFeeSavingInsurance === 'percent' ? -20 : -50, marginTop: 6 }}
                      >
                        {currencyFeeSavingInsurance === 'percent' ? '%' : 'Rupiah'}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <ErrorDiv error={errorSaving} />
                    </div>
                    <div className="col-6 pl-1 d-flex align-items-center">
                      <ErrorDiv error={errorInsurance} />
                    </div>
                  </div>

                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="feeSavingLate"
                    label="Biaya Simpan Keterlambatan"
                    defaultValue={currencyFeeSavingLate}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorSavingLate} />
                </div>
                <div className="col-6 pr-0">
                  <SelectCurrencyInput
                    id="lateCharge"
                    label="Biaya Denda Keterlambatan (Per-Hari)"
                    defaultValue={currencyLateCharge}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorChargeLate} />

                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <TextInput
                    suffix="Kali"
                    label="Maksimum Perpanjangan"
                    onChange={(e) => setMaxExtension(e.target.value)}
                  />
                  <ErrorDiv error={errorMaxExtend} />
                </div>
                <div className="col-6 pr-0">
                  <TextInput
                    suffix="Hari"
                    label="Maksimum Keterlambatan"
                    onChange={(e) => setMaxLate(e.target.value)}
                  />
                  <ErrorDiv error={errorMaxLate} />
                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="feeAuction"
                    label="Biaya Jasa Lelang"
                    defaultValue={currencyFeeAuction}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorFeeAuction} />
                </div>
                <div className="col-6 pr-0">
                  <TextInput
                    suffix="Hari"
                    label="Masa Tenggang"
                    onChange={(e) => setGracePeriod(e.target.value)}
                  />
                  <ErrorDiv error={errorGracePeriod} />
                </div>
              </div>

              {/* <div className="container-sk">
                <p>Tanggal Berlaku</p>
                <CustomDatePicker
                  id={"date"}
                  isRangePicker
                  width="50%"
                  onInputChange={handleDateChange}
                  value={dateValue}
                />
                <ErrorDiv error={errorDate} />
              </div> */}
            </div>
          </div>

          <div className="ml-auto d-flex align-items-center justify-content-end">
            <Button
              onClick={() => history.push(AppRoutePath.CAMPAIGN_DEFAULT, { list: 'loan' })}
              className="btn-action"
              style={{
                width: 120,
                height: 36,
                margin: 5,
                background: "#fff",
                border: "0.75px solid #DCDCDC",
                color: "#2C465C",
              }}
            >
              Kembali
            </Button>
            <Button
              variant="primary"
              className="btn-action btn-add"
              style={{ width: 120, height: 36, margin: 5 }}
              onClick={onSubmit}
            >
              Tambah
            </Button>
          </div>
        </div>

        <RegulerInformation />
      </div>
    </div>
  );
}
